import { Component } from '@angular/core';
import { IntroOneComponent } from './intro-one.component';

@Component({
  selector: 'eid-intro-one-mobile',
  templateUrl: './intro-one.mobile.component.html',
  styleUrls: ['./intro-one.mobile.component.scss']
})
export class IntroOneMobileComponent extends IntroOneComponent {}
